/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @enum {string}
 */
export enum ShipmentActivityType {
  ProNumberChanged = "PRO_NUMBER_CHANGED",
  CarrierPickupNumberChanged = "CARRIER_PICKUP_NUMBER_CHANGED",
  NoteAdded = "NOTE_ADDED",
  CompanyNoteAdded = "COMPANY_NOTE_ADDED",
}

export function instanceOfShipmentActivityType(value: any): boolean {
  for (const key in ShipmentActivityType) {
    if (Object.prototype.hasOwnProperty.call(ShipmentActivityType, key)) {
      if (
        ShipmentActivityType[key as keyof typeof ShipmentActivityType] === value
      ) {
        return true;
      }
    }
  }
  return false;
}

export function ShipmentActivityTypeFromJSON(json: any): ShipmentActivityType {
  return ShipmentActivityTypeFromJSONTyped(json, false);
}

export function ShipmentActivityTypeFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ShipmentActivityType {
  return json as ShipmentActivityType;
}

export function ShipmentActivityTypeToJSON(
  value?: ShipmentActivityType | null,
): any {
  return value as any;
}

export function ShipmentActivityTypeToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): ShipmentActivityType {
  return value as ShipmentActivityType;
}
